import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import _ from "lodash";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import PropTypes from "prop-types";

import { refreshingCongnitoUserTokens, validateUserSession as validateUserAction } from "../redux/actions/authActions";

import Dashboard from "../views/Dashboard/example/VoiceHubDashboard";
import Assistant from "../views/Assistant/Assistant";
import Profile from "../views/Profile/Profile";
import UnderDevelopment from "../views/UnderDevelopment/UnderDevelopment";
import NotFound from "../views/NotFound/NotFound";
import Users from "../views/Users/Users";
import Connections from "../views/Connections";
import Subscriptions from "../views/Subscriptions";
import FaqCms from "../views/FaqCms";
import SubmitAndListFaqs from "../views/FaqCms/components/SubmitAndListFaqs";
import FaqCmsSettings from "../views/FaqCms/components/Settings";
import ConnectionOverview from "../views/ConnectionOverview";
import Interact from "../views/Interact/Interact";
import Intents from "../views/Intents";
import IntentsEnabled from "../views/IntentsEnabled";
import SignIn from "../views/SignIn/SignIn";
import SignUp from "../views/SignUp/SignUp";
import CustomSlots from "../views/CustomSlots/CustomSlots";
import ForgotPassword from "../views/ForgotPassword/ForgotPassword";
import history from "../history";
import GettingStartedWizard from "../views/GettingStartedWizard/GettingStartedWizard";
import ConnectionEnable from "../views/ConnectionEnable";
import UtteranceTraining from "../views/UtteranceTraining";
import ResponseManager from "../views/ActionButtons/ActionButtonList";
import BubbleSettings from "../views/BubbleSettings";
import ChatbotSettings from "../views/ChatbotSettings";
import ResponseEditor from "../views/ActionButtons/components/ActionButtonEditor/ActionButtonEditor";
import ActionButtonCreator from "../views/ActionButtons/components/ActionButtonCreator/ActionButtonCreator";


import { CircularProgress } from "@material-ui/core";

// Material helpers
import { MuiThemeProvider } from "@material-ui/core/styles";

// Theme
import theme from "../theme";
import { Analytics } from "aws-amplify";  
import { buildBot, checkBotStatus, triggerBotBuilding, triggerCheckBotStatus } from "../redux/actions/intentsActions";
import { pushMessage, removeMessage, setAppType } from "../redux/actions/commonActions";

// Additional CSS
import "./style.css";

import { FAQ_CMS_FAQS_PATH, FAQ_CMS_CONTENT_EDITOR_PATH, FAQ_CMS_SETTINGS_PATH, SALES_SUBDOMAIN } from "../constants";

const defaultRoutes = [
  { 
    path: "/under-development", 
    component: UnderDevelopment,
    routeType: "default",
    disabledAccessApps: []
  },
  { 
    path: "/dashboard", 
    component: Dashboard,
    routeType: "private",
    disabledAccessApps: [SALES_SUBDOMAIN]
  },
  { 
    path: "/profile", 
    component: Profile,
    routeType: "public",
    disabledAccessApps: []
  },
  { 
    path: "/sign-up", 
    component: SignUp,
    routeType: "public",
    disabledAccessApps: []
  },
  { 
    path: "/sign-in", 
    component: SignIn,
    routeType: "public",
    disabledAccessApps: []
  },
  { 
    path: "/forgot-password", 
    component: ForgotPassword,
    routeType: "public",
    disabledAccessApps: []
  },
  { 
    path: "/users", 
    component: Users,
    routeType: "private",
    disabledAccessApps: []
  },
  { 
    path: "/assistant", 
    component: Assistant,
    routeType: "private",
    disabledAccessApps: [SALES_SUBDOMAIN]
  },
  { 
    path: "/manage-connections", 
    component: Connections,
    routeType: "private",
    disabledAccessApps: []
  },
  { 
    path: "/manage-subscriptions", 
    component: Subscriptions,
    routeType: "private",
    disabledAccessApps: [SALES_SUBDOMAIN]
  },
  { 
    path: "/enabled-intents/:connection_name", 
    component: IntentsEnabled,
    routeType: "private",
    disabledAccessApps: []
  },
  { 
    path: "/action-buttons/:action_id", 
    component: ResponseEditor,
    routeType: "private",
    disabledAccessApps: []
  },
   { 
    path: "/action-button-create", 
    component: ActionButtonCreator,
    routeType: "private",
    disabledAccessApps: []
  },
  { 
    path: "/connection-enabled", 
    component: ConnectionEnable,
    routeType: "private",
    disabledAccessApps: []
  },
  { 
    path: "/custom-slots", 
    component: CustomSlots,
    routeType: "private",
    disabledAccessApps: []
  },
  { 
    path: "/getting-started-wizard", 
    component: GettingStartedWizard,
    routeType: "private",
    disabledAccessApps: []
  },
  { 
    path: "/utterance-training", 
    component: UtteranceTraining,
    routeType: "admin",
    disabledAccessApps: []
  },
  { 
    path: "/action-buttons", 
    component: ResponseManager,
    routeType: "admin",
    disabledAccessApps: []
  },
  { 
    path: FAQ_CMS_FAQS_PATH, 
    component: SubmitAndListFaqs,
    routeType: "private",
    disabledAccessApps: []
  },
  { 
    path: FAQ_CMS_CONTENT_EDITOR_PATH, 
    component: FaqCms,
    routeType: "admin",
    disabledAccessApps: []
  },
  { 
    path: FAQ_CMS_SETTINGS_PATH, 
    component: FaqCmsSettings,
    routeType: "admin",
    disabledAccessApps: []
  },
  { 
    path: "/website-assistant", 
    component: ChatbotSettings,
    routeType: "private",
    disabledAccessApps: [SALES_SUBDOMAIN]
  },
  { 
    path: "/bubble-settings", 
    component: BubbleSettings,
    routeType: "admin",
    disabledAccessApps: [SALES_SUBDOMAIN]
  },
  {
    path: "/not-found", 
    component: NotFound,
    routeType: "public",
    disabledAccessApps: []
  }
];

const PublicRoute = ({ component: ReactComponent, defaultPath, authStatus, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      typeof authStatus === "undefined" || authStatus === false ? (
        <ReactComponent {...props} />
      ) : (
        <Redirect to={defaultPath} />
      )
    }
  />
);

function refreshCognitoUserInRedux(refreshingCongnitoUserTokens) {
  return refreshingCongnitoUserTokens();
}

const PrivateRoute = ({ component: ReactComponent, authStatus, refreshingCongnitoUserTokens, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (typeof authStatus === "undefined" || authStatus === false) {
          return (
            <Redirect
              to={{
                pathname: "/sign-in",
                state: {
                  from: props.location
                }
              }}
            />
          );
        } else { 
          refreshCognitoUserInRedux(refreshingCongnitoUserTokens);
          return <ReactComponent {...props} />;
        }
      }}
    />
  );
};

const AdminRoute = ({ component: ReactComponent, defaultPath, authStatus, refreshingCongnitoUserTokens, admin, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (typeof authStatus === "undefined" || authStatus === false || !admin) {
          return (
            <Redirect
              to={{
                pathname: {defaultPath},
                state: {
                  from: props.location
                }
              }}
            />
          );
        } else {
          refreshCognitoUserInRedux(refreshingCongnitoUserTokens);
          return <ReactComponent {...props} />;
        }
      }}
    />
  );
};

const DefaultRoute = ({ authStatus, defaultPath, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        typeof authStatus === "undefined" || authStatus === false ? (
          <Redirect to="/sign-in" />
        ) : (
          <Redirect to={defaultPath} />
        )
      }
    />
  );
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.handleWindowClose = this.handleWindowClose.bind(this);
  }

  componentDidMount() {
    this.setAppType();
    this.sessionInterval = setInterval(() => {
      if (this.props.authenticated) {
        this.props.refreshingCongnitoUserTokens();
      }
    }, 150000);
  }

  componentWillMount() {
    // if session contains valid
    this.validateUser();
    window.addEventListener("beforeunload", this.handleWindowClose);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleWindowClose);
    clearInterval(this.sessionInterval);
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (
      ((this.props.authenticated && nextProps.skill !== this.props.skill && nextProps.skill) ||
        nextProps.checkBotStatusTriggered) &&
        !nextProps.botBuildTriggered &&
        window.location.href.indexOf("wizard") === -1
    ) {
      this.handleBotStatus(true);
      if (nextProps.checkBotStatusTriggered) {
        this.props.triggerCheckBotStatus(false);
      }
    }

    if (
      this.props.authenticated &&
      nextProps.botBuildTriggered &&
      nextProps.botBuildTriggered !== this.props.botBuildTriggered
    ) {
      this.buildBotAndShowProgress();
    }
  }

  handleWindowClose = async e => {
    e.preventDefault();
    // dispatch a UNAUTH_USER action to invoke Cognito
  };

  validateUser() {
    // get current authenticated user
    this.props.validateUserAction();
  }

  setAppType(){
    if(this.props.appType)return;
    this.props.setAppType("default");
    var subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
    if(subdomain){
      this.props.setAppType(subdomain);
    } 
  }

  async handleBotStatus(initialCheck = false) {
    await this.props.checkBotStatus();
    // console.log("this.props.botStatus", this.props.botStatus);
    if (this.props.botStatus["refresh"] === false) {
      if (this.props.botStatus.type === "error") {
        this.props.pushMessage({
          message:
            "Your environment experienced internal issue. Please go to manage connections screen and click on build Responsum button. If this message persist contact your administrator.",
          type: "error",
          removePrevious: true
        });
        this.props.triggerBotBuilding(false);
      } else if (this.props.botStatus.type === "success" && !initialCheck) {
        this.props.pushMessage({
          message: "Your environment is ready. You can now use Responsum chat bot. ",
          type: "success",
          removePrevious: true
        });
        // this.props.triggerBotBuilding(false);
      } else if (this.props.botStatus.type === "warning") {
        this.props.pushMessage({
          message: this.props.botStatus.message,
          type: "success"
        });
        this.props.triggerBotBuilding(false);
      }
    } else {
      let messagePushed = false;
      this.props.allMessages.forEach(function(message) {
        if (message.message.content.includes("Your Responsum environment is being built")) {
          messagePushed = true;
        }
      });
      if (!messagePushed) {
        this.props.pushMessage({
          message: "Your Responsum environment is being built. Please wait few minutes...",
          type: "info",
          persist: true
        });
        // this.props.triggerBotBuilding(true);
      }

      setTimeout(() => {
        this.handleBotStatus(false);
      }, this.props.botStatus["refreshInterval"]);
    }
  }

  async buildBotAndShowProgress() {
    let messagePushed = false;
    this.props.allMessages.forEach(function(message) {
      if (message.message.content.includes("Your Responsum environment is being built")) {
        messagePushed = true;
      }
    });
    if (!messagePushed) {
      this.props.pushMessage({
        message: "Your Responsum environment is being built. Please wait few minutes...",
        type: "info"
      });
      // this.props.triggerBotBuilding(true);
    }

    await this.props.buildBot();

    if (this.props.botBuilt["successful"] === true) {
      this.handleBotStatus(false);
    } else {
      this.props.pushMessage({
        message:
          "Your environment experienced internal issue. Please go to manage connections screen and click on build Responsum button. If this message persist contact your administrator.",
        type: "error",
        removePrevious: true
      });
      this.props.triggerBotBuilding(false);
    }
  }


  render() {
    const { administrator, appType } = this.props;

    //set default redirect route based on app type(eventually it will all be dashboard)
    const defaultRoute = "/dashboard";

    const routes = defaultRoutes.map(route => {
        if(route.disabledAccessApps.includes(appType))return null;
        let returnRoute;
        switch(route.routeType){
        case "private": 
        returnRoute = <PrivateRoute
                  component={route.component}
                  exact path={route.path}
                  defaultRoute={defaultRoute}
                  authStatus={this.props.authenticated}
                  refreshingCongnitoUserTokens={this.props.refreshingCongnitoUserTokens} />
        break;
        case "admin": 
        returnRoute = <AdminRoute 
                  component={route.component}
                  exact path={route.path} 
                  admin={administrator}
                  defaultRoute={defaultRoute}
                  authStatus={this.props.authenticated}
                  refreshingCongnitoUserTokens={this.props.refreshingCongnitoUserTokens} />
        break;
        case "public": 
        returnRoute = <PublicRoute
                  component={route.component}
                  exact path={route.path}
                  defaultRoute={defaultRoute}
                  authStatus={this.props.authenticated} />
        break;
        default:
        returnRoute = <DefaultRoute
                  component={route.component}
                  exact path={route.path}
                  defaultRoute={defaultRoute}
                  authStatus={this.props.authenticated} />
      } 
      return returnRoute;
    })

    if (typeof this.props.authenticated === "undefined") {
      return (
        <div
          style={{
            transform: "translate(-50%, -50%)",
            position: "absolute",
            top: "50%",
            left: "50%"
          }}
        >
          <CircularProgress />
        </div>
      );
    } else {
      return (
        <MuiThemeProvider theme={theme}>
          <CssBaseline /> {/* material ui version of normalize.css or other css resets */}
          <DndProvider backend={HTML5Backend}>
            <Router history={history}>
              <Switch>
                <Redirect exact from="/" to={defaultRoute} />
                  {routes}
                <Redirect to="/not-found" />
              </Switch>
            </Router>
          </DndProvider>
        </MuiThemeProvider>
      );
    }
  }
}

// Runtime type checking for React props
App.propTypes = {
  validateUser: PropTypes.func,
  history: PropTypes.object,
  errorMessage: PropTypes.string
};

Analytics.autoTrack("pageView", {
  enable: true,
  eventName: "pageView",
  attributes: {
    path: window.location.pathname,
    tenant: "signup",
    environment: `${process.env.NODE_ENV}`
  },
  type: "SPA",
  provider: "AWSPinpoint",
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    cognitoUser: state.auth.cognitoUser,
    botBuilt: state.intents["botBuilt"] ? state.intents.botBuilt : {},
    botStatus: state.intents["botStatus"] ? state.intents.botStatus : {},
    botBuildTriggered: state.intents["botBuildTriggered"] ? state.intents.botBuildTriggered : false,
    checkBotStatusTriggered: state.intents["checkBotStatusTriggered"] ? state.intents.checkBotStatusTriggered : false,
    skill: state["skill"] ? state.skill : {},
    allMessages: _.get(state, "common.allMessages", []),
    administrator: _.get(state, "auth.cognitoUser.attributes.custom:role", "user") === "Administrator",
    appType: state.common.appType??null
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        validateUserAction,
        checkBotStatus,
        buildBot,
        triggerBotBuilding,
        triggerCheckBotStatus,
        refreshingCongnitoUserTokens,
        removeMessage,
        pushMessage,
        setAppType
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
